export const agentMatchingTypes = [
    { label: 'All', value: 'all' },
    { label: 'Single Match', value: 'single' },
    { label: 'Multiple Match', value: 'multiple' },
];
